// @ts-nocheck
import { useEffect, useState } from "react";

import { AvailableProductsResponse } from "@/libraries/bxp-web-stargate-client/src";
import { ConfirmationPageTemplate } from "@/templates/ondemand/signup/confirmation/confirmation-page/src";
import { useGupsStatus } from "@/templates/ondemand/signup/confirmation/confirmation-page/src/hooks";

import { getFeatureFlagValues } from "../../../../wac-routes";

export type ConfirmationPageProps = {
    availableProducts: AvailableProductsResponse | null;
};

export const ConfirmationPage = ({
    availableProducts
}: ConfirmationPageProps) => {
    const { getProfileCallback } = useGupsStatus();
    const [subAnchor, setSubAnchor] = useState();

    useEffect(() => {
        const abortController = new AbortController();

        const getData = async () => {
            try {
                const result = await getProfileCallback(abortController.signal);

                // Check if component is still mounted before updating state
                if (abortController.signal.aborted) {
                    return;
                }

                if (result?.error) {
                    console.log(`gups profile error ${result.error}`);
                }
                if (result?.data) {
                    const { data } = result;
                    setSubAnchor(
                        data?.paidChannelContext?.confluence?.subAnchor
                    );
                }
            } catch (error) {
                // Don't log AbortErrors as they're expected when component unmounts
                if (error instanceof Error && error.name !== "AbortError") {
                    console.error("Error getting GUPS profile:", error);
                }
            }
        };

        getData();

        // Cleanup function to abort request if component unmounts
        return () => {
            abortController.abort();
        };
    }, [getProfileCallback]);
    return (
        <ConfirmationPageTemplate
            featureFlags={
                window.featureFlags ||
                getFeatureFlagValues(window.location.search.split("&"))
            }
            isProduction={process.env["CLIENT_LIBRARY_ENV"] === "production"}
            subAnchor={subAnchor}
            availableProducts={availableProducts}
        />
    );
};
